import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    canonical?: string;
    keywords?: string;
    type?: string;
    image?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    schema?: any;
}

const SEO = ({ title, description, canonical, keywords, type = 'website', image, schema }: SEOProps) => {
    const baseTitle = "CitoyenPro";
    const defaultDesc = "La plateforme n°1 pour préparer et réussir l'examen de citoyenneté canadienne. 500+ quiz, flashcards interactives et examens blancs.";
    const baseUrl = "https://citoyenpro.nnt-quebec.com";
    
    // Si aucun titre n'est fourni, on utilise un titre accrocheur global
    const finalTitle = title ? `${title} | ${baseTitle}` : `${baseTitle} - La référence de l'Examen de Citoyenneté Canadienne`;
    
    // On construit l'url finale avec le tag canonical
    const finalUrl = canonical ? `${baseUrl}${canonical}` : baseUrl;
    const ogImage = image ? `${baseUrl}${image}` : `${baseUrl}/logo/app-logo.png`;

    const defaultSchema = {
       "@context": "https://schema.org",
       "@type": "WebSite",
       "name": baseTitle,
       "url": baseUrl,
       "description": defaultDesc,
       "sameAs": [
           "https://www.facebook.com/citoyenpro",
           "https://twitter.com/citoyenpro"
       ]
    };

    return (
        <Helmet>
            <title>{finalTitle}</title>
            <meta name="description" content={description || defaultDesc} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={finalUrl} />

            <meta property="og:site_name" content={baseTitle} />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={finalTitle} />
            <meta property="og:description" content={description || defaultDesc} />
            <meta property="og:url" content={finalUrl} />
            <meta property="og:image" content={ogImage} />
            
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={finalTitle} />
            <meta name="twitter:description" content={description || defaultDesc} />
            <meta name="twitter:image" content={ogImage} />

            <script type="application/ld+json">
                {JSON.stringify(schema || defaultSchema)}
            </script>
        </Helmet>
    );
};

export default SEO;
